import { useCallback } from 'react';
import { hapticFeedback } from '@tma.js/sdk-react';

import { useAppSelector } from '@/store/hooks';

type ImpactStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
type NotificationType = 'error' | 'success' | 'warning';

/**
 * Wrapper around Telegram haptic feedback that respects the user's
 * settings.hapticsEnabled preference and silently no-ops outside Telegram.
 */
export function useHaptics() {
  const enabled = useAppSelector((s) => s.settings.hapticsEnabled);

  const impact = useCallback(
    (style: ImpactStyle = 'light') => {
      if (!enabled) return;
      try {
        hapticFeedback.impactOccurred(style);
      } catch {
        /* not in Telegram */
      }
    },
    [enabled],
  );

  const notification = useCallback(
    (type: NotificationType) => {
      if (!enabled) return;
      try {
        hapticFeedback.notificationOccurred(type);
      } catch {
        /* not in Telegram */
      }
    },
    [enabled],
  );

  const selection = useCallback(() => {
    if (!enabled) return;
    try {
      hapticFeedback.selectionChanged();
    } catch {
      /* not in Telegram */
    }
  }, [enabled]);

  return { impact, notification, selection };
}
